import { render, staticRenderFns } from "./LocalityUsersDrawer.vue?vue&type=template&id=146f8cb6"
import script from "./LocalityUsersDrawer.vue?vue&type=script&lang=js"
export * from "./LocalityUsersDrawer.vue?vue&type=script&lang=js"
import style0 from "./LocalityUsersDrawer.vue?vue&type=style&index=0&id=146f8cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports